
import { axiosClient } from "./axoisClient";

export const getComapnyInfo = (id, token) => {
  return axiosClient.get(`companies/${id}`, {
    headers : {
      Authorization : 'Bearer ' + token
    }
  });
};
